import { createSlice, WithSlice } from '@reduxjs/toolkit';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { rootReducer } from '@ui/store';

import { reducers } from './actions';
import { createNewPartUserPriceQuoteLineReducer } from './extra-reducers/create-new-part-user-price-quote-line';
import { createSnapQuoteLineReducer } from './extra-reducers/create-snap-quote-line';
import { createSnapQuoteLineAttachmentReducer } from './extra-reducers/create-snap-quote-line-attachment';
import { deleteSnapQuoteLineAttachmentReducer } from './extra-reducers/delete-snap-quote-line-attachments';
import { editSnapQuoteReducer } from './extra-reducers/edit-snap-quote';
import { importSpreadsheetReducer } from './extra-reducers/import-spreadsheet';
import { issuesDrawerReducer } from './extra-reducers/issues-drawer';
import { createSendQuoteReducer } from './extra-reducers/send-quote';
import { showSalesRepReducer } from './extra-reducers/show-sales-rep';
import { defaultState } from './utilities/default-state';

export const quoteBuilderReducer = createSlice({
  name: QUOTE_BUILDER_SLICE_NAME,
  initialState: defaultState,
  reducers,
  // @TODO(#2403): Replace with imported selectors once Root state type guards are removed
  selectors: {
    selectQuoteBuilder: (state) => state,
  },
  extraReducers: (builder) => {
    createSnapQuoteLineAttachmentReducer(builder);
    createNewPartUserPriceQuoteLineReducer(builder);
    createSnapQuoteLineReducer(builder);
    deleteSnapQuoteLineAttachmentReducer(builder);
    editSnapQuoteReducer(builder);
    showSalesRepReducer(builder);
    createSendQuoteReducer(builder);
    issuesDrawerReducer(builder);
    importSpreadsheetReducer(builder);
  },
});

export const quoteBuilderSlice = quoteBuilderReducer.injectInto(rootReducer);

export const { actions, selectors: quoteBuilderSelectors } = quoteBuilderSlice;

declare module '@ui/store' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface LazyLoadedSlices
    extends WithSlice<typeof quoteBuilderReducer> {}
}
